import {useEffect, useCallback, useRef, useState} from 'react';

import {useStores} from '../../../Hooks';
import {fetchItemAccessSources, openShareItemModal} from './privacyHelpers';

const usePrivacySection = (settings, {isProjectLevel} = {}) => {
    const {generalStore, modalStore, projectStore} = useStores();
    const addRef = useRef(null);
    const workspace = generalStore.workspace;
    const itemId = settings.itemId;
    const nestedRoute = settings.nestedRoute;
    const projectId = isProjectLevel ? null : projectStore.currentProject?.ProjectIdentifier;
    const prefetchedAccess = modalStore.modalData?.prefetchedAccess;

    const [isAccessLoaded, setIsAccessLoaded] = useState(false);
    const initAccessRef = useRef(settings.initAccessState);
    initAccessRef.current = settings.initAccessState;
    const load = async () => {
        try {
            if (prefetchedAccess) {
                initAccessRef.current(prefetchedAccess);
                setIsAccessLoaded(true);
                return;
            }
            const result = await fetchItemAccessSources(workspace, {itemId, nestedRoute});
            initAccessRef.current(result);
            setIsAccessLoaded(true);
        } catch (error) {
            console.error('Failed to fetch access:', error);
        }
    };
    useEffect(() => {
        if (isProjectLevel || !itemId) return;
        load();
    }, [itemId, nestedRoute, workspace, isProjectLevel]);

    const handleOpenShare = useCallback(() => {
        openShareItemModal({
            workspace,
            projectId,
            currentAccessSources: settings.editedAccessSources,
            modalStore,
            addRef,
            itemType: settings.itemType,
            onSave: (selectedIds, selectedGroups, selectedMembers) => {
                settings.setEditedAccessSources(selectedIds);
                settings.setAccessGroups(selectedGroups);
                settings.setAccessMembers(selectedMembers);
            },
        });
    }, [workspace, projectId, settings.editedAccessSources, settings.itemType, modalStore]);

    return {addRef, handleOpenShare, isAccessLoaded: isProjectLevel ? settings.isAccessLoaded : isAccessLoaded};
};

export default usePrivacySection;
